module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-regular-400.ttf?87dab6ff12ea107dafe1d52ec19c2ed8";